import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IFullTeamAssessment } from '../models/fullTeamAssessment';
import { ErrorService } from '../helpers/errorService';
import { IRMSPlanChecklist } from '../models/rmsPlanChecklist';
import { IRoarAssignmentForm } from '../models/roarAssignmentForm';

@Injectable({
  providedIn: 'root'
})
export class RoarAssignmentFormService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getRoarAssignmentFormByRoarId(roarId: string): Observable<IRoarAssignmentForm> {
        const url = environment.apiBaseUrl + endpoints.getRoarAssignmentFormByRoarId.replace(':roarId', roarId);
        return this.http.get<IRoarAssignmentForm>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getRoarAssignmentFormByCaseId(caseId: string): Observable<IRoarAssignmentForm[]> {
        const url = environment.apiBaseUrl + endpoints.getRoarAssignmentFormByCaseId.replace(':caseId', caseId);
        return this.http.get<IRoarAssignmentForm[]>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getCompletedRoarAssignmentFormByCaseId(caseId: string): Observable<IRoarAssignmentForm[]> {
        const url = environment.apiBaseUrl + endpoints.getCompletedRoarAssignmentFormByCaseId.replace(':caseId', caseId);
        return this.http.get<IRoarAssignmentForm[]>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createRoarAssignmentForm(data: IRoarAssignmentForm): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.createRoarAssignmentForm;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    updateRoarAssignmentForm(data: IRoarAssignmentForm): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRoarAssignmentForm;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    updateRoarActivity(data: IRoarAssignmentForm): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRoarActivity;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    updateRoarReview(data: IRoarAssignmentForm): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRoarReview;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}